import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
import { formatDate, creatDownload } from '@/utils/formUtils'
import {
  compare,
  getdayType,
  cycleChange,
  getDeliveryType
} from 'enumeration/lab-order.js'

import billDatas from '@/store/actions/datas/bill'
import productionTaskDatas from '@/store/actions/datas/production-task'
import { trustDeedList } from 'json/trust-deed'
import { getEnumeration } from 'enumeration'
import orderflowHelper from '@/config/order'
import { getPlateType } from '@/utils/plateType'

export default {
  getProductionTasksList(ctx, data) {
    return fetch.getProductionTasksList(data).then(res => {
      res.data.forEach(ele => {
        ele = productionTaskDatas.formatTaskDetail(ele)
      })
      return getTotalNumber(res)
    })
  },
  prodTasksExportExcel(ctx, data) {
    return fetch.prodTasksExportExcel(data).then(res => {
      return res.data
    })
  },
  getProductionTasksDetail(ctx, id) {
    return fetch.getProductionTasksDetail(id).then(res => {
      let { bill, productionTask, status } = res.data
      if (bill) bill = billDatas.formatBillDetail(bill)
      productionTask = productionTaskDatas.formatTaskDetail(productionTask)
        // logs = logs?.sort(compare('operationTime'))
        // // logs.forEach(e => {
        // //   e.orderStatusResult = formatOperationLog(e.orderStatusResult)
        // // })

      // let task = null
      // // 将tasks写到最新状态的childStatus字段内
      // /* global _ */
      // if (_.isArray(tasks) && tasks.length > 0) {
      //   task = tasks[0]
      // }
      return {
        productionTask,
        status,
        bill
      }
    })

  },
  taskReassgin(ctx, data) {
    return fetch.taskReassgin(data).then(res => {
      return res.data
    })
  },
  taskDelay(ctx, data) {
    return fetch.taskDelay(data).then(res => {
      return res.data
    })
  },
  getProductionTaskExportExcel(ctx, data) {
    return fetch.getProductionTaskExportExcel(data).then(res => {
      return res.data
    })
  },
  removeOrdersFromTask(ctx, data) {
    return fetch.removeOrdersFromTask(data).then(res => {
      return res.data
    })
  },
  addOrdersToTask(ctx, data) {
    return fetch.addOrdersToTask(data).then(res => {
      return res.data
    })
  },
  getOrderCountByTask(ctx, data) {
    return fetch.getOrderCountByTask(data).then(res => {
      return res.data
    })
  },
  distributeOrderFromTask(ctx, data) {
    return fetch.distributeOrderFromTask(data).then(res => {
      return res.data
    })
  },
  updateTask(ctx, data) {
    return fetch.updateTask(data).then(res => {
      return res.data
    })
  },
  closeTask(ctx, id) {
    return fetch.closeTask(id).then(res => {
      return res.data
    })
  },
  deleteTask(ctx, id) {
    return fetch.deleteTask(id).then(res => {
      return res.data
    })
  },
  getProductionTaskDownloadExcel(ctx, data) {
    return fetch.getProductionTaskDownloadExcel(data).then(res => {
      return res.data
    })
  }
}